export const getBooxiLifetime = (product) => {
  return product?.booxi_item_info?.expired_time;
};

export const isVirtualCartItem = (product) => {
  return product.__typename === 'VirtualCartItem' || product.__typename === 'VirtualProduct';
};
